import type { SearchableSelectConfig } from '@/components/SearchableSelect';

export const RULES_SEARCHABLE_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'level',
    title: 'Level',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'buttongroup'
    },
    filterOptions: [
      {
        id: 1,
        label: 'Global',
        value: 'global'
      },
      {
        id: 2,
        label: 'Organization',
        value: 'organization'
      }
    ]
  },
  {
    field: 'file_type',
    title: 'File Type',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: [
      {
        id: 1,
        label: 'Configuration',
        value: 'configuration'
      },
      {
        id: 2,
        label: 'Rule',
        value: 'rule'
      },
      {
        id: 3,
        label: 'Feed Rule',
        value: 'feed_rule'
      }
    ]
  }
];

// colors
export const RULES_BLUE = '#2197cc';
export const RULES_PURPLE = '#af7bb8';
